module.exports = __webpack_public_path__ + "static/media/7.b8ce3ab1.gif";